import React, { useState, useEffect } from 'react'
import { Button } from "@mui/material";
import blogServices from './services/blogs'
import LoginForm from './components/LoginForm'
import BlogForm from './components/BlogForm'
import SignupForm from './components/SignupForm'
import CurrentBlogs from './components/CurrentBlogs'

function App() {
  const [ user, setUser ] = useState(null)
  const [ blogs, setBlogs ] = useState([])
  const [ newUser, setNewUser ] = useState(false)

  useEffect(() => {
    const localUser = JSON.parse(window.localStorage.getItem('localUser'))
    if (localUser) {
      blogServices.setToken(localUser.token)
      setUser(localUser)
    }
  }, [])

  const handleLogout = () =>  {
    setUser(null)
    window.localStorage.removeItem('localUser')
  }

  //Use chatgpt to create summary

  return (
    <div>
      {user ?
        <>
          <div className="header">
            <h1 style={{ color: 'rgb(255, 165, 0)' }}>Welcome {user.name}</h1>
            <Button onClick={handleLogout} id="logout">Logout</Button>
          </div>
          <BlogForm 
            blogs={blogs}
            setBlogs={setBlogs}
            user={user}
            handleLogout={handleLogout}
          />
        <CurrentBlogs
          blogs={blogs}
          setBlogs={setBlogs}
          handleLogout={handleLogout}
          user={user}
        />
        </> :
        newUser ?
          <SignupForm setUser={setUser} /> :
          <LoginForm setUser={setUser} setNewUser={setNewUser} />
      }
    </div>
  );
}

export default App;
